import axios from 'axios';

import { camelizeKeys } from '../lib/json-blob-case.ts';

declare module 'axios' {
  interface AxiosRequestConfig {
    /** 请求指定的原始 JSON 数据块，仅外层字段转换键名。 */
    opaqueJsonBlobKeys?: readonly string[];
  }
}

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/admin',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：注入 Authorization header
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器：解包 SuccessResponse + snake_case → camelCase + 401 跳登录
apiClient.interceptors.response.use(
  (response) => {
    // 1. 解包 SuccessResponse { data: T, message: string }
    if (
      response.data &&
      typeof response.data === 'object' &&
      'data' in response.data &&
      'message' in response.data
    ) {
      // 检查业务层 success 字段
      if ('success' in response.data && response.data.success === false) {
        const msg = response.data.message || '操作失败';
        return Promise.reject(new Error(msg));
      }
      response.data = response.data.data;
    }
    // 2. 顶层 schema 转 camelCase；capabilities / parameters 保持库内蛇形
    response.data = camelizeKeys(response.data, response.config.opaqueJsonBlobKeys);
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;
    // 提取后端错误信息
    const msg = data?.message || data?.detail || error.message;

    if (status === 401) {
      const url = error.config?.url || '';
      if (!url.includes('/auth/login')) {
        localStorage.removeItem('admin_token');
        const returnTo = window.location.pathname + window.location.search + window.location.hash;
        window.location.href = `/login?${new URLSearchParams({ returnTo })}`;
      }
    }
    return Promise.reject(Object.assign(new Error(msg), { status }));
  }
);

export { apiClient };
